import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import FancyButton from './ui/shiny-button';
import { FOOTER_LINKS } from '../data/mock';

const DiscordIcon = ({ size = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.888 7.335a5.134 5.134 0 0 0-2.893-2.418a9.144 9.144 0 0 0-2.275-.508a9.963 9.963 0 0 0-.508 1.038a15.039 15.039 0 0 0-4.56 0a11.372 11.372 0 0 0-.519-1.038c-.752.082-1.493.249-2.208.497a5.123 5.123 0 0 0-2.904 2.44a16.176 16.176 0 0 0-1.91 9.717a16.562 16.562 0 0 0 4.98 2.528a4.339 4.339 0 0 0 1.104-1.777c-.54-.202-1.06-.45-1.557-.74c-.089-.122.254-.32.364-.354a11.826 11.826 0 0 0 10.037 0c.1 0 .453.232.364.354c-.441.342-1.424.585-1.59.828a7.4 7.4 0 0 0 1.105 1.69a16.628 16.628 0 0 0 4.99-2.53a16.232 16.232 0 0 0-2.02-9.727M8.669 14.7a1.943 1.943 0 0 1-1.92-1.955a1.943 1.943 0 0 1 1.92-1.91a1.942 1.942 0 0 1 1.933 1.965a1.943 1.943 0 0 1-1.933 1.9m6.625 0a1.943 1.943 0 0 1-1.932-1.944a1.932 1.932 0 1 1 3.865.034a1.932 1.932 0 0 1-1.933 1.899z" />
  </svg>
);

const XIcon = ({ size = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const iconConfig = {
  instagram: { Icon: ({ size = 22 }) => <Instagram size={size} strokeWidth={1.8} />, variant: 'pink' },
  x: { Icon: XIcon, variant: 'white' },
  discord: { Icon: DiscordIcon, variant: 'indigo' },
  mail: { Icon: ({ size = 22 }) => <Mail size={size} strokeWidth={1.8} />, variant: 'red' },
};

const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-white/10 backdrop-blur-md bg-black/40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-6 flex items-center justify-between flex-wrap gap-4">
        <div className="text-[11px] tracking-[0.22em] text-white/55">© 2026 KIUA MUSIC GROUP</div>

        <div className="flex items-center gap-3 md:gap-4">
          {FOOTER_LINKS.map((link) => {
            const cfg = iconConfig[link.icon];
            if (!cfg) return null;
            const { Icon, variant } = cfg;
            return (
              <FancyButton
                key={link.id}
                href={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
                ariaLabel={link.label}
                variant={variant}
                icon={<Icon size={20} />}
                className="text-white"
              />
            );
          })}
        </div>

        <div className="hidden md:block w-[180px]"></div>
      </div>
    </footer>
  );
};

export default Footer;
